import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { env } from '@/lib/env';

const msalConfig: Configuration = {
  auth: {
    clientId: env.ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${env.ENTRA_TENANT_ID}`,
    redirectUri: env.ENTRA_REDIRECT_URI,
    postLogoutRedirectUri: window.location.origin + '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};
